const specialCharactersRegex = /[.*+?^${}()|[\]\\]/g;
const escapeCharacter = '\\$&';
export function fuzzy(searchTerm, items = [], cap = 0.1, splitComma = true) {
  if (items.length === 0) return items;

  const parseTerms = searchTerm.toLowerCase().trim().replace(specialCharactersRegex, escapeCharacter);
  let splitTerms;
  if (splitComma) splitTerms = parseTerms.split(',').map(v => v.trim());
  else splitTerms = [parseTerms];

  return splitTerms.flatMap(term => {
    return items.map(item => {
      if (!item) return { distance: 0 };

      if (typeof item === 'object' && Array.isArray(item.enums)) {
        return {
          label: item.label,
          value: item.value,
          distance: JaroWrinker(term, item.label.toLowerCase().trim()),
          enums: item.enums.map(sub => {
            let label = sub.label || sub.value;
            if (!label) return { distance: 0 };
            return {
              label,
              value: sub.value,
              distance: JaroWrinker(term, label.toLowerCase().trim())
            }
          })
          .filter(v => v.distance > cap)
          .sort((a, b) => a.distance - b.distance)
        }
      } else {
        return {
          label: item?.label || item,
          value: item?.value || item,
          cap: item?.threshold || cap,
          distance: JaroWrinker(term, (item?.label || item).toLowerCase().trim())
        }
      }
    })
    .filter(v => v.distance > (v.cap || cap))
  })
  .sort((a, b) => a.distance - b.distance);

}


function JaroWrinker(s1, s2) {
  if (s1.length === 0 || s2.length === 0) return 0;
  if (s1 === s2) return 1;

  let m = 0;
  let range = (Math.floor(Math.max(s1.length, s2.length) / 2)) - 1;
  let s1Matches = new Array(s1.length);
  let s2Matches = new Array(s2.length);

  for (let i = 0; i < s1.length; i++) {
    let low = i >= range ? i - range : 0;
    let high = i + range <= s2.length ? i + range : s2.length - 1;

    for (let j = low; j <= high; j++) {
      if (s1Matches[i] !== true && s2Matches[j] !== true && s1[i] === s2[j]) {
        ++m;
        s1Matches[i] = true;
        s2Matches[j] = true;
        break;
      }
    }
  }

  // Exit early if no matches were found.
  if (m === 0) return 0;

  // Count the transpositions.
  let k = 0;
  let n_trans = 0;

  for (let i = 0; i < s1.length; i++) {
    if (s1Matches[i] === true) {
      let j;
      for (j = k; j < s2.length; j++) {
        if (s2Matches[j] === true) {
          k = j + 1;
          break;
        }
      }
      if (s1[i] !== s2[j]) ++n_trans;
    }
  }

  let weight = (m / s1.length + m / s2.length + (m - (n_trans / 2)) / m) / 3;
  let l = 0;
  let p = 0.1;

  if (weight > 0.7) {
    while (s1[l] === s2[l] && l < 4) {
      ++l;
    }
    weight = weight + l * p * (1 - weight);
  }

  return weight;
}